/*
 * @Author: tanyaohua
 * @Date: 2021-07-22 13:29:31
 * @LastEditTime: 2021-08-11 10:53:37
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\labelSelect\labelSelect.js
 * @Description: 
 */
angular.module('editPageModule').directive('labelSelectDirective', ['trsspliceString', 'trsHttpService', 
    function(trsspliceString, trsHttpService) {
        return {
            scope: true,
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/labelSelect/labelSelect.html',
            replace: false,
            link: function($scope, ele) {
                initStatus();
                initData();     

                /**
                 * [initStatus description]
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        options: [],
                        selectedOptions: [],
                        searchWord: '',
                        selectedArray: [],
                    };
                }

                /**
                 * [initData description] 初始换数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    queryAllGenre();
                    // $scope.list.LABEL = $scope.list.LABEL ? $scope.list.LABEL : '';
                    // console.log($scope.list.LABEL);
                    // initLabel();
                    // console.log($scope.list.LABEL);
                }

                /**
                 * [queryAllGenre description]获取所有产品列表
                 * @param  {[type]}  name   [name description]
                 * @return  {[type]}   [return description]
                 */
                function queryAllGenre() {
                    // $scope.data.options = [{id: 1, name: '11'}, {id: 2, name: '223'}, {id: 3, name: '33'}];
                    var params = {
                        serviceid: 'zmy_userlabel',
                        methodname: 'queryUserLabels',
                        keyword: $scope.data.searchWord,
                        CURRPAGE: 1,
                        PAGESIZE: 500
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.options = data && data.DATA ? data.DATA : [];
                    });
                }

                // 监听字段，在编辑的时候该字段返回的是格式是数组，需要改编成自己需要的格式
                $scope.$watch('list.LABELDESC', function(newV) {
                    if (newV && !$scope.data.selectedOptions.length) {
                        initLabel();
                    }
                });

                /**
                 * [initLabel description]初始化label
                 *
                 * @return  {[type]}  [return description]
                 */
                function initLabel() {
                    var nameArr = $scope.list.LABELDESC.split(',');
                    var idArr = $scope.list.LABEL.split(',');
                    $scope.data.selectedOptions = nameArr.map((item, index) => ({
                        LABELNAME: item,
                        USERLABELID: idArr[index]
                    }));
                }

                /**
                 * [getLabel description]组合需要的数组
                 *
                 * @param   {[type]}  attr  [attr description]
                 * @return  {[type]}        [return description]
                 */
                function getLabel(attr) {
                    return trsspliceString.spliceString($scope.data.selectedOptions, attr, ',');
                }
                $scope.deleteLabel = function () {
                    $scope.list.LABEL = getLabel('USERLABELID');
                    $scope.list.LABELDESC = getLabel('LABELNAME');
                };
                
                // 选择标签时
                $scope.labelSelect = function(item) {
                    if (!$scope.isSelected(item)) {
                        $scope.data.selectedOptions.push(item);
                    } else {
                        $scope.data.selectedOptions = $scope.data.selectedOptions.filter((item2) => item2.USERLABELID !== item.USERLABELID);
                    }
                    $scope.list.LABEL = getLabel('USERLABELID');
                    $scope.list.LABELDESC = getLabel('LABELNAME');
                };

                $scope.isSelected = function(item) {
                    return $scope.data.selectedOptions.some((item2) => item2.USERLABELID === item.USERLABELID);
                };

                // 在组件销毁时删掉该参数
                $scope.$on('$destroy', function() {
                    $scope.list.LABELDESC = $scope.list.LABEL = undefined;
                    delete $scope.list.LABEL;
                    delete $scope.list.LABELDESC;
                });
            }
        };
    }
]);
